"use client";

import { usePathname } from "next/navigation";
import FocusStartDialog from "@/components/focus/FocusStartDialog";
import FocusTimerWidget from "@/components/focus/FocusTimerWidget";
import BreakScreen from "@/components/focus/BreakScreen";
import FocusPrompts from "@/components/focus/FocusPrompts";
import FocusThemeController from "@/components/focus/FocusThemeController";
import FocusPageEffects from "@/components/focus/FocusPageEffects";

/**
 * Pojedynczy montaż w root layout — dzięki temu timer i ekran przerwy przeżywają
 * całą nawigację client-side (między lekcjami, zakładkami panelu itd.). Cały
 * interfejs skupienia pokazujemy TYLKO w obszarze nauki (kurs / platforma) — nigdy
 * na stronie logowania czy landingu, dzięki czemu sesja z innego konta nie „wycieka".
 */
export default function FocusTimerLayer() {
  const pathname = usePathname() ?? "";
  const inLearningArea =
    (pathname.startsWith("/kurs/") || pathname.startsWith("/platforma")) && !pathname.startsWith("/platforma/login") && !pathname.startsWith("/platforma/register");
  const isLesson = /^\/kurs\/[^/]+\/lekcja\//.test(pathname);

  const widgetPos = isLesson ? "right-3 sm:right-6 bottom-20 sm:bottom-6" : "right-4 sm:right-6 bottom-5 sm:bottom-6";
  const promptPos = isLesson
    ? "left-1/2 -translate-x-1/2 bottom-36 sm:bottom-8"
    : "left-1/2 -translate-x-1/2 bottom-24 sm:bottom-8";

  return (
    <>
      {/* Dialog startu — event-driven; nieszkodliwy poza obszarem nauki (nie otwiera się) */}
      <FocusStartDialog />

      {inLearningArea && (
        <>
          {/* Spokojny motyw + odliczanie w tytule + powiadomienia + ekran przerwy */}
          <FocusThemeController />
          <FocusPageEffects />
          <BreakScreen />
          <FocusTimerWidget positionClass={widgetPos} />
          <FocusPrompts positionClass={promptPos} />
        </>
      )}
    </>
  );
}
